/**
 * Internal dependencies
 */
import './woocommerce';

import { listenToClickEvent } from './click';
import { listenToElementViewEvent } from './element-view';
import {
	listenToJavaScriptFormSubmission,
	prepareFormForSyncingEventInWordPress,
} from './form-submission';
import { listenToScrollEvent } from './scroll';
import { listenToTimeOnPageEvent } from './time-on-page';
import { listenToVideoPlaybackEvent } from './video-playback';
import { listenToWooCommerceAddToCartEvent } from './wc-add-to-cart';

import type { ActionListener } from '../../types';

export const LISTENERS: ReadonlyArray< ActionListener > = [
	listenToClickEvent,
	listenToElementViewEvent,
	listenToJavaScriptFormSubmission,
	listenToScrollEvent,
	listenToTimeOnPageEvent,
	listenToVideoPlaybackEvent,
	listenToWooCommerceAddToCartEvent,
	prepareFormForSyncingEventInWordPress,
];
